<script>
import { whereAmIClicked } from "./slider_utils.mjs";

import { debug } from "/vodalys/.jslibs";
const log = debug("FDoubleSlider");

export default {
  methods: {},
  props: {
    start: Number,
    stop: Number,
  },
  data: function () {
    return {
      step: 0,
      stepWidth: 0,
      cursorLeft: 0,
      cursorLeftClicked: false,
      cursorRight: 0,
      cursorRightClicked: false,
      mouseDown: false,
      value: "",
      sliderWidth: undefined,
    };
  },
  computed: {
    cssVars() {
      return {
        "--cursorLeft": this.cursorLeft + "px",
        "--cursorRight": this.cursorRight + "px",
      };
    },
    sliderElt() {
      return this.$refs.sliderElt;
    },
  },
  mounted: function () {
    window.addEventListener("mousemove", this.mousemove);
    // window.addEventListener("mousedown", this.mousedown);
    window.addEventListener("mouseup", this.mouseup);
  },
  beforeDestroy: function () {
    window.removeEventListener("mousemove", this.mousemove);
    // window.removeEventListener("mousedown", this.mousedown);
    window.removeEventListener("mouseup", this.mouseup);
  },
  methods: {
    mousedown: function ($event) {
      const clickX = whereAmIClicked(this.sliderElt, $event);

      this.sliderWidth = this.sliderElt.getBoundingClientRect().width;

      const fillWidth =
        this.$el.getElementsByClassName("f-fill")[0].offsetWidth;

      if (clickX < this.cursorLeft) {
        this.cursorLeftClicked = true;
      } else if (clickX > this.cursorLeft + fillWidth) {
        this.cursorRightClicked = true;
      } else if (clickX < this.cursorLeft + fillWidth / 2) {
        this.cursorLeftClicked = true;
      } else if (clickX > this.cursorLeft + fillWidth / 2) {
        this.cursorRightClicked = true;
      }

      this._mousemove(clickX);
    },
    mouseup: function ($event) {
      this.cursorLeftClicked = false;
      this.cursorRightClicked = false;
    },
    mousemove: function ($event) {
      const clickX = whereAmIClicked(this.sliderElt, $event);
      this._mousemove(clickX);
    },
    _mousemove: function (relativeLeft) {
      const sliderWidth =
        this.$el.getElementsByClassName("f-slider")[0].offsetWidth;

      if (this.cursorLeftClicked) {
        let newPosition = relativeLeft - 12;

        newPosition = Math.max(newPosition, 0);
        newPosition = Math.min(
          newPosition,
          sliderWidth - this.cursorRight - 48
        );

        this.cursorLeft = newPosition;

        this.$emit("startchange", (this.cursorLeft * 100) / sliderWidth);
      } else if (this.cursorRightClicked) {
        let newPosition = sliderWidth - relativeLeft - 12;
        newPosition = Math.max(newPosition, 0);
        newPosition = Math.min(newPosition, sliderWidth - this.cursorLeft - 48);

        this.cursorRight = newPosition;

        this.$emit(
          "stopchange",
          ((sliderWidth - this.cursorRight) * 100) / sliderWidth
        );
      }
    },
  },
  watch: {
    start: function (v) {
      v = isNaN(parseInt(v)) ? 0 : parseInt(v);

      const sliderWidth =
        this.$el.getElementsByClassName("f-slider")[0].offsetWidth;

      var newWidth = (sliderWidth * v) / 100;

      if (this.cursorLeft + 32 >= sliderWidth - newWidth) return;

      this.cursorLeft = newWidth;
    },
    stop: function (v) {
      v = isNaN(parseInt(v)) ? 0 : parseInt(v);

      const sliderWidth =
        this.$el.getElementsByClassName("f-slider")[0].offsetWidth;

      var newWidth = (sliderWidth * (100 - v)) / 100;

      if (this.cursorLeft + 32 >= sliderWidth - newWidth) return;

      this.cursorRight = newWidth;
    },
  },
};
</script>
    
<template>
  <f-field>
    <template v-slot:label><slot name="label"></slot></template>
    <template v-slot:content>
      <div class="f-double-slider-container">
        <div
          class="f-slider"
          @mousedown="mousedown"
          :style="cssVars"
          ref="sliderElt"
        >
          <div class="f-container">
            <div class="f-background"></div>
            <div class="f-fill-left"></div>
            <div
              class="f-cursor left"
              :class="{ pressed: cursorLeftClicked }"
            ></div>
            <div class="f-fill"></div>
            <div
              class="f-cursor right"
              :class="{ pressed: cursorRightClicked }"
            ></div>
            <div class="f-fill-right"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:helper><slot name="helper"></slot></template>
  </f-field>
</template>

<style lang="scss" scoped>
.f-double-slider-container {
  display: flex;

  // colors:
  // colors:
  .f-background {
    background-color: var(--blue-a5);
    &:hover {
      background-color: var(--blue-a10);
    }
    &:active {
      background-color: var(--blue-a25);
    }
  }
  .f-fill {
    background-color: var(--turquoise);
    &:hover {
      background-color: var(--turquoise-d90);
    }
    &:active {
      background-color: var(--turquoise-d80);
    }
  }
  .f-cursor {
    &:hover::after {
      background-color: var(--blue-a25);
    }
    &:active::after,
    &.pressed::after {
      background-color: var(--blue-a75);
    }
  }

  .f-slider {
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    height: 48px;
    cursor: pointer;
    user-select: none;
    .f-container {
      position: relative;
      flex: 1 1 100%;
      height: 8px;
      border-radius: 4px;
      display: flex;
      user-select: none;
      // pointer-events: none;

      .f-background {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .f-fill {
        position: relative;
        flex: 1 1 auto;
        height: 100%;
        user-select: none;
        // pointer-events: none;
      }

      .f-fill-left {
        width: calc(var(--cursorLeft));
        user-select: none;
        // pointer-events: none;
      }

      .f-fill-right {
        width: calc(var(--cursorRight));
        user-select: none;
        // pointer-events: none;
      }

      .f-cursor {
        width: 24px;
        height: 24px;
        background: #ffffff;
        box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.25);
        border-radius: 16px;
        position: relative;
        top: -8px;
        // pointer-events: none;
        user-select: none;

        &::after {
          content: "";
          display: block;
          height: 12px;
          width: 12px;
          border-radius: 16px;
          position: absolute;
          left: 6px;
          top: 6px;
        }
      }
    }
  }
}

.dark-mode {
  .f-double-slider-container {
    display: flex;

    // colors:
    // colors:
    .f-background {
      background-color: var(--navigation-a5);
      &:hover {
        background-color: var(--navigation-a10);
      }
      &:active {
        background-color: var(--navigation-a25);
      }
    }
    .f-fill {
      background-color: var(--primary);
      &:hover {
        background-color: var(--primary-d90);
      }
      &:active {
        background-color: var(--primary-d80);
      }
    }
    .f-cursor {
      &:hover::after {
        background-color: var(--navigation-a25);
      }
      &:active::after,
      &.pressed::after {
        background-color: var(--navigation-a75);
      }
    }
  }
}
</style>